import { me } from '@/externals/gyym/user'

export const getMe = async () => {
  return await me.get()
}

export const updateMe = async (params: me.MeUpdateParams) => {
  return await me.update(params)
}

export const getGradeNotification = async () => {
  return await me.getGradeNotification()
}

export const markGradeNotificationAsRead = async () => {
  return await me.markGradeNotificationAsRead()
}

export const listGradeHistories = async () => {
  return await me.listGradeHistories()
}
